import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import { useSelector } from 'react-redux';

const ModalCrearOrdenCompra = ({ isOpen, toggle, onSave }) => {
    const [formData, setFormData] = useState({
        CLAEMP: '',
        NROODC: '',
        TIPODC: '',
        FECODC: '',
        ESTADO: '',
        VALTOT: '',
        // Add more fields as needed
    });
    const tenantId = useSelector((state) => state.Context.tenantId);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        const dataToSend = { ...formData, tenantId };
        onSave(dataToSend);
        setFormData({
            CLAEMP: '',
            NROODC: '',
            TIPODC: '',
            FECODC: '',
            ESTADO: '',
            VALTOT: '',
        }); // Reset
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Crear Orden de Compra</ModalHeader>
            <ModalBody>
                <Form>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="CLAEMP">Empresa</Label>
                                <Input type="number" name="CLAEMP" id="CLAEMP" value={formData.CLAEMP} onChange={handleChange} />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="NROODC">Número Orden</Label>
                                <Input type="number" name="NROODC" id="NROODC" value={formData.NROODC} onChange={handleChange} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="TIPODC">Tipo Orden</Label>
                                <Input type="select" name="TIPODC" id="TIPODC" value={formData.TIPODC} onChange={handleChange}>
                                    <option value="">Seleccionar</option>
                                    <option value="1">Vehículos</option>
                                    <option value="2">General</option>
                                    <option value="3">Importación</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="FECODC">Fecha Orden</Label>
                                <Input type="date" name="FECODC" id="FECODC" value={formData.FECODC} onChange={handleChange} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="ESTADO">Estado</Label>
                                <Input type="select" name="ESTADO" id="ESTADO" value={formData.ESTADO} onChange={handleChange}>
                                    <option value="">Seleccionar</option>
                                    <option value="0">Vigente</option>
                                    <option value="1">Con recepción parcial</option>
                                    <option value="2">Recepción completa</option>
                                    <option value="3">Cerrada</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="VALTOT">Valor Total</Label>
                                <Input type="number" step="0.01" name="VALTOT" id="VALTOT" value={formData.VALTOT} onChange={handleChange} />
                            </FormGroup>
                        </Col>
                    </Row>
                    {/* Add more fields as needed */}
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSave}>Guardar</Button>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalCrearOrdenCompra;